import { gql } from "@apollo/client";

const WHATSAPP_CALL_SIGNALING = gql`
  subscription whatsappCallSignaling($agentId: ID!) {
    whatsappCallSignaling(agentId: $agentId) {
      id
      callId
      inboxId
      agentId
      from
      customerName
      status
      sdpOffer
      sdpAnswer
      direction
    }
  }
`;

export default WHATSAPP_CALL_SIGNALING;
